import { Logo } from '@perch-labs/shrike';
import { copy } from './copy';
import { routes } from './routes';
import { theme } from './theme';

export const base = {
  copy,
  logo: Logo,
  routes,
  theme,
};
